import { forwardRef } from "react";
import { Box, Flex } from "rebass/styled-components";
import { useRecoilValue } from "recoil";
import styled from "styled-components";

import { OPGGHeader } from "../OPGGEmbeddablePlaylist";
import { Thumbnails } from "../Thumbnails";

import { VerticalDivider } from "MVVM/Components/Divider";
import { LoadingSkeleton } from "MVVM/Components/Skeloton";
import {
  ActivePlaylistClipState,
  VisiblePlaylistClipsState,
} from "MVVM/State/embeddablePlaylist";
import EmbeddablePlayer from "MVVM/Views/EmbeddablePlayer";

export const HorizontalPlaylistLayout = forwardRef<
  HTMLDivElement,
  { platform: string }
>(({ platform }, ref) => {
  const activePlaylistClip = useRecoilValue(ActivePlaylistClipState);
  const visiblePlaylistClips = useRecoilValue(VisiblePlaylistClipsState);

  return (
    <StyledContainer>
      <OPGGHeader
        title={activePlaylistClip?.title || ""}
        isHorizontalLayout={true}
      />
      <StyledLayoutContainer>
        <PlayerContainer ref={ref}>
          {activePlaylistClip ? (
            <EmbeddablePlayer
              className="horizontal-player-component"
              userRole="viewer"
              onPlayEndVariant="nextUpPlaylist"
            />
          ) : (
            <PlayerLoadingSkeleton>
              <LoadingSkeleton width="100%" height="100%" />
            </PlayerLoadingSkeleton>
          )}
        </PlayerContainer>
        <VerticalDivider
          width="1px"
          height="100%"
          mx={2}
          background="#1C1C1F"
        />
        <Thumbnails
          clipsToDisplay={visiblePlaylistClips}
          platform={platform}
          renderLolPlaylist
        />
      </StyledLayoutContainer>
    </StyledContainer>
  );
});

const StyledContainer = styled(Flex)`
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const StyledLayoutContainer = styled(Flex)`
  background: #282830;
  flex: 1;
  flex-direction: row;
  gap: 12px;
  height: 100%;
  min-height: 0;
  width: 100%;
`;

const PlayerContainer = styled(Box)`
  aspect-ratio: 16/9;
  flex: 0 0 auto;
  margin: 20px 0 20px 20px;
  overflow: hidden;
  position: relative;

  .horizontal-player-component {
    height: 100%;
    width: 100%;
  }

  .horizontal-player-component .embeddable-player {
    height: 100% !important;
  }

  .horizontal-player-component .video-js {
    height: 100% !important;
    width: 100% !important;
    background: transparent;
  }

  .horizontal-player-component [data-vjs-player] {
    height: 100% !important;
  }

  .horizontal-player-component [data-vjs-player] > div {
    height: 100% !important;
  }

  .horizontal-player-component > .overlay {
    height: calc(100% - 54px) !important;
  }

  .horizontal-player-component .vjs-control-bar {
    z-index: 10 !important;
  }

  @media (min-width: 901px) {
    .horizontal-player-component .content-display {
      left: calc(50%);
      transform: translate(-50%, -40%);
    }
  }

  .vjs-tech {
    border-radius: 8px;
    height: 100% !important;
    width: 100% !important;
  }
`;

const PlayerLoadingSkeleton = styled(Box)`
  border-radius: 8px;
  height: 100%;
  width: 100%;
`;
